import {
    addBikeProRequest,
    addBikeRequest,
    deleteBikeRequest,
    editBikeProRequest,
    editBikeRequest,
    getBikeListRequest,
    getBikeRequest,
    updateBikeRequest,
} from '../../../services/network/sell/bike';

class CommonBikeService {
    async addBike(values) {
        return await addBikeRequest(values);
    }

    async addBikePro(values) {
        return await addBikeProRequest(values);
    }

    async getBike(id) {
        return await getBikeRequest(id);
    }

    async getBikeList(payload) {
        return await getBikeListRequest(payload);
    }

    async deleteBike(id) {
        return await deleteBikeRequest(id);
    }

    async editBike(updates) {
        return await editBikeRequest(updates);
    }

    async editBikePro(updates) {
        return await editBikeProRequest(updates);
    }

    async updateBike(updates) {
        return await updateBikeRequest(updates);
    }
}

export const BikeService = new CommonBikeService();
